import { z } from 'zod';
// Personal data schema for booking form
export const PersonalDataSchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().optional(),
    email: z.string().email('Please enter a valid email address').optional().or(z.literal('')),
    phone: z.string().optional(),
    countryCode: z.string().optional().default('de'), // ISO country code for phone number
    contactPermission: z.boolean().optional().default(false),
    marketingConsent: z.boolean().optional().default(false),
    isFirstVisit: z.boolean().optional(), // "Waren Sie schon einmal bei uns?"
}).refine((data) => data.email || data.phone, {
    message: 'Either email or phone is required',
    path: ['phone'], // Show error on phone field
});
// Booking steps enum
export const BookingStepSchema = z.enum(['personal', 'service', 'team', 'datetime', 'confirmation']);
// Main booking state schema
export const BookingStateSchema = z.object({
    step: BookingStepSchema,
    personalData: PersonalDataSchema.optional(),
    serviceId: z.string().uuid().optional(),
    teamMemberId: z.string().uuid().optional(),
    date: z.string().optional(), // ISO date string
    time: z.string().optional(), // HH:mm format
});
// Booking request schema for API
export const CreateBookingRequestSchema = z.object({
    tenantId: z.string().uuid(),
    serviceId: z.string().uuid(),
    teamMemberId: z.string().uuid(),
    startTime: z.string().datetime(),
    endTime: z.string().datetime(),
    customerData: PersonalDataSchema,
    notes: z.string().optional(),
});
// Time slot schema
export const TimeSlotSchema = z.object({
    startTime: z.string(),
    endTime: z.string(),
    available: z.boolean(),
    reason: z.string().optional(), // If not available, why?
});
// Available slots response schema
export const AvailableSlotsSchema = z.object({
    date: z.string(),
    slots: z.array(TimeSlotSchema),
});
